const actionPrefix = (actionType) => `Messages/${actionType}`;

export const PUSH_MESSAGE = actionPrefix`PUSH_MESSAGE`;
export const pushMessage = (message) => ({
  type: PUSH_MESSAGE,
  payload: message,
});

export const CLEAR_MESSAGES = actionPrefix`CLEAR_MESSAGES`;
export const clearMessages = () => ({
  type: CLEAR_MESSAGES,
});
